import { Box, Dialog } from "@mui/material"
import { key } from "../../../core/Env";
import { Buttons } from "../../../core/global/Buttons"
import { SuccessSaving } from "../../../core/global/Modal";
import { createPersonalization } from "../../../core/request/Global";

export const Congratulation = ({history, onboarding, uid, Cafgu, profile_state}) => {
    const handleClose = async() => {
        let prsnl_data = {
            user_id: uid, 
            tool_id: key('tid'), 
            feature_name: 'onboarding', 
            personalization:[
                {sf_name: 'profiling', status: 1},
                {sf_name: 'welcome', status: 1},
                {sf_name: 'home_tour', status: 1},
            ]
        }
        await createPersonalization(prsnl_data);
        let onb = {...onboarding.data}
        onb.home_tour = {...onb.home_tour, stat: false, drawer: false}
        onboarding.set(onb)
    };
    
    const escFunction = async(event) => {
        if(event.keyCode === 27) {
            handleClose()
        }
    }

    const handleProceed = () => {
        let onb = {...onboarding.data}
        onb.home_tour.drawer = false
        onboarding.set(onb)
    }
    
  return (
    <Box>
        <Dialog open={onboarding.data.home_tour.drawer} onKeyDown={(e)=>escFunction(e)} PaperProps={{ sx:{ borderRadius: '16px'}}} BackdropProps={{sx: {backgroundColor: 'rgba(0, 0, 0, 75%)'}}}>
            <Box maxWidth={420}>
                <Box component="img" src={Cafgu} alt="cafgu-img" />
                <Box textAlign="center" my={1} >
                    <Box fontSize={24} fontWeight="bold">
                        <Box>Congratulations!</Box> 
                    </Box>
                    <Box fontSize={12} my={2} className="line-height" color="#000">You've successfully created your account</Box>
                        <Box fontSize={14}>Let me show you some</Box> 
                        <Box fontSize={14} display="flex" justifyContent="center">
                            <Box >great features of </Box>
                            <Box px={.5} color="primary.main" fontWeight={500}>POFAcademy!</Box>
                        </Box>
                </Box>
                <Box display="flex" alignItems="center" justifyContent="center" mt={2} mb={3}>
                    <Box width="352px" display="flex" justifyContent="center"  >
                        <Buttons event={handleClose} margin="0px 12px 0px 0px " borderRadius="8px" variant="contained" color="skip" width="100%" height="48px" text={<b>Skip</b>} />
                        <Buttons event={()=>handleProceed()}  margin="0px 12px 0px 0px " borderRadius="8px" variant="contained" color="primary" width="100%" height="48px" text={<b>Proceed</b>} />
                    </Box>
                </Box>
                <Box display="flex" alignItems="center" justifyContent="center" mb={3}>
                    <Box width={24} height={4} bgcolor="#0984E3" borderRadius={4} mr={1} />
                    <Box width={24} height={4} bgcolor="#0984E3" borderRadius={4} />
                </Box>
            </Box>
        </Dialog>
        <SuccessSaving successSaving={profile_state.successSaving.data} setSuccessSaving={profile_state.successSaving.set} text="User account details was successfully saved" />  
    </Box>
  )
}